import React from 'react';
import classNames from 'classnames';
import { getThemeVariableValue } from '#app/containers/ThemeLoader';
import LiquidNobleLogoTitleDark from '#components/Elements/SVGIcon/LiquidNobleLogoTitleDark';
import styles from './PlatformLogo.scss';

export default function PlatformLogo({ width, height, leftAligned }) {
  const headerLogoUrl = getThemeVariableValue('header-logo-url');
  const platformTitle = getThemeVariableValue('platform-title');

  return (
    <>
      {headerLogoUrl ? (
        <img
          className={classNames(styles.platformLogo, {
            [styles.leftAligned]: leftAligned,
          })}
          src={headerLogoUrl}
          alt={platformTitle}
        />
      ) : (
        <LiquidNobleLogoTitleDark width={width} height={height} />
      )}
    </>
  );
}
